// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button__btn--3Ct-aWeeVR"};